import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

/**
 * Crea una newsletter. Si se adjunta fichero, se sube a `uploads/newsletters/<id>/...`
 * y se guarda en `url` (Canva) o `imageUrl` (plantilla Brevo con {{ contact.IMAGEN }}).
 */
export const postNewsletter = async (newsletter, selectedFile) => {
  const createRes = await authClient().post(`${API}/newsletter`, newsletter);

  const createdId = createRes?.data?._id;
  if (selectedFile && createdId) {
    const response = await uploadSingleFile(
      selectedFile,
      `newsletters/${createdId}`,
    );
    const fileURL = response?.data?.fileURL;
    if (fileURL) {
      const patch =
        newsletter?.isCanva === true
          ? { url: fileURL }
          : { imageUrl: fileURL };
      await authClient().put(`${API}/newsletter/${createdId}`, {
        ...newsletter,
        ...patch,
      });
    }
  }

  return createRes;
};

export const duplicarNewsletter = async (id, newsletter) => {
  return authClient().post(`${API}/newsletter/${id}`, newsletter);
};

export const getNewsletters = () => {
  return authClient().get(`${API}/newsletter?getDisabled=true`);
};

export const getNewsletterById = (id) => {
  return authClient().get(`${API}/newsletter/${id}`);
};

export const updateNewsletter = async (id, newsletter, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, `newsletters/${id}`);
    const fileURL = response?.data?.fileURL;
    if (fileURL) {
      if (newsletter?.isCanva === true) newsletter.url = fileURL;
      else newsletter.imageUrl = fileURL;
    }
  }
  return authClient().put(`${API}/newsletter/${id}`, newsletter);
};

export const changeStatusNewsletter = async (id, active) => {
  return authClient().put(`${API}/newsletter/change-status/${id}`, { active });
};

export const deleteNewsletter = (id) => {
  return authClient().delete(`${API}/newsletter/${id}`);
};
